<!--
 * @Author: HWD
 * @Date: 2021-11-05 13:39:45
 * @LastEditors: HWD
 * @LastEditTime: 2021-11-18 11:12:13
 * Copyright 2021 © HWD, All Rights Reserved. 
 * @Description: 
-->
<template>
    <div class="movecar">
        <swiper :source="window.source"/>
        <qr-code :source="window.source" />
        <!-- <spread-register :source="window.spreadId" /> -->
    </div>
</template>
<script>
import Swiper from "@/components/Swiper"
import QrCode from "@/components/QrCode"
//import SpreadRegister from "@/components/SpreadRegister"
//import Spread from '@/components/Spread'
//import Fetch from "../utils/fetch";
export default {
  name: "App",
  components: {
    Swiper,
    QrCode,
    //Spread,
    //SpreadRegister
  },
  data() {
    return {
      window:{
        source:'',
        spreadId:'',
        userId:''
      },
   
    };
  },
  created() {
    //this.getUrlObj()
    
    this.window.source = this.getUrlObj().id
    //this.getData() 
  },
  mounted() {
    
  },
  updated() {},
  //computed () {},
  methods: {
    getUrlObj() {
      var ret = {};
      console.log(location.search, location);
      var search = location.search.slice(1);
      console.log(search);
      search.replace(/([^?&]+)=([^?&]+)/g, function (s, v, k) {
        ret[v] = decodeURIComponent(k);
        //return k + "=" + v;
      });
      console.log(ret);
      return ret;
    },
   
  },
};
</script>